export const SHOW_DISCLAIMER_MESSAGE = 'SHOW_DISCLAIMER_MESSAGE';
